export default __webpack_public_path__ + "static/media/timer_s1.26745bbc.png";